import { lazy, Suspense, useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { SiteProvider } from "./lib/site";
import Layout from "./components/site/Layout";
import Home from "./pages/Home";
import TrialsHow from "./pages/TrialsHow";
import Catalogue from "./pages/Catalogue";
import ProductDetail from "./pages/ProductDetail";
import HomeMods from "./pages/HomeMods";
import Participants from "./pages/Participants";
import Referrers from "./pages/Referrers";
import Funding from "./pages/Funding";
import About from "./pages/About";
import Faqs from "./pages/Faqs";
import Contact from "./pages/Contact";
import RequestTrial from "./pages/RequestTrial";
import Collection from "./pages/Collection";
import Legal from "./pages/Legal";
import NotFound from "./pages/NotFound";

const AdminApp = lazy(() => import("./admin/AdminApp"));

function ScrollTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) return el.scrollIntoView();
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

export default function App() {
  return (
    <SiteProvider>
      <BrowserRouter>
        <ScrollTop />
        <Routes>
          <Route path="/admin/*" element={<Suspense fallback={<p className="p-10">Loading dashboard…</p>}><AdminApp /></Suspense>} />
          <Route element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="equipment-trials" element={<TrialsHow />} />
            <Route path="equipment" element={<Catalogue />} />
            <Route path="equipment/:slug" element={<ProductDetail />} />
            <Route path="home-modifications" element={<HomeMods />} />
            <Route path="participants-families" element={<Participants />} />
            <Route path="referrers" element={<Referrers />} />
            <Route path="ndis-funding" element={<Funding />} />
            <Route path="about" element={<About />} />
            <Route path="faqs" element={<Faqs />} />
            <Route path="contact" element={<Contact />} />
            <Route path="request-trial" element={<RequestTrial />} />
            <Route path="equipment-return" element={<Collection />} />
            <Route path="privacy" element={<Legal page="privacy" />} />
            <Route path="terms" element={<Legal page="terms" />} />
            <Route path="accessibility" element={<Legal page="accessibility" />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </SiteProvider>
  );
}
